import CurrencySetup from './currency_setup';

export const replaceSymbolMarkerWithSymbol = setup => x => x.replace(CurrencySetup.symbolMarker, setup.symbol);
